<div class="container-focus" [class.selected]="focused">
  <ng-content> </ng-content>
</div>
